// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header styling */

.server-side-datatable {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.server-side-datatable .loading-overlay {
  position: relative;
  z-index: 100;
}

.server-side-datatable .table-header {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0px;
  margin-top: 0px;
  padding: 0px 8px;
  min-height: 44px;
}

.server-side-datatable .custom-ag-table-container {
  flex: 1 1;
  min-height: 0;
  margin-left: 4px;
  margin-right: 4px;
}

.server-side-datatable .ag-header {
  border-bottom: 2px solid #e0e0e0;
  font-weight: 600;
}

.server-side-datatable .ag-header-cell {
  border-right: 1px solid #e0e0e0;
  padding: 8px 12px;
}

.server-side-datatable .ag-header-cell-text {
  font-weight: 600;
  font-size: 13px;
}

/* Row styling */
.server-side-datatable .ag-row {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
}

.server-side-datatable .ag-row:hover {
  background-color: #f8f9fa;
}

.server-side-datatable .ag-row.ag-row-selected {
  background-color: #e3f2fd;
}

.server-side-datatable .ag-row.ag-row-selected:hover {
  background-color: #bbdefb;
}

/* Cell styling */
.server-side-datatable .ag-cell {
  border-right: 1px solid #f0f0f0;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 1.4;
}

/* Typography overrides: Poppins, 14px, 24px line-height, 400 weight, rgba(0,0,0,0.87) */
.server-side-datatable .ag-header,
.server-side-datatable .ag-header-cell,
.server-side-datatable .ag-header .ag-header-cell-text {
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  line-height: 24px !important;
  font-weight: 500 !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

.server-side-datatable .ag-cell {
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  line-height: 24px !important;
  font-weight: 400 !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

/* Menus, lists and overlays keep consistent typography */
.server-side-datatable .ag-menu,
.server-side-datatable .ag-virtual-list-item,
.server-side-datatable .ag-overlay-loading-center,
.server-side-datatable .ag-overlay-no-rows-center {
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  line-height: 24px !important;
  font-weight: 400 !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

/* Checkbox styling */
.server-side-datatable .ag-selection-checkbox {
  margin-right: 8px;
}

/* Loading overlay styling */
.server-side-datatable .ag-overlay-loading-wrapper {
  background-color: rgba(255, 255, 255, 0.9);
}

.server-side-datatable .ag-overlay-loading-center {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* No rows overlay styling */
.server-side-datatable .ag-overlay-no-rows-wrapper {
  background-color: rgba(255, 255, 255, 0.9);
}

.server-side-datatable .ag-overlay-no-rows-center {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 20px;
  font-size: 14px;
  color: #666;
}

/* Pagination styling */
.server-side-datatable .ag-paging-panel {
  border-top: 1px solid #e0e0e0;
  background-color: #fafafa;
  padding: 8px 12px;
}

.server-side-datatable .ag-paging-button {
  border: 1px solid #ddd;
  background-color: white;
  margin: 0 2px;
  border-radius: 3px;
  padding: 4px 8px;
  font-size: 12px;
}

.server-side-datatable .ag-paging-button:hover:not(.ag-disabled) {
  background-color: #f5f5f5;
}

.server-side-datatable .ag-paging-button.ag-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Filter styling */
.server-side-datatable .ag-filter-toolpanel {
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Sort indicator styling */
.server-side-datatable .ag-header-cell-sorted-asc .ag-header-cell-text::after,
.server-side-datatable .ag-header-cell-sorted-desc .ag-header-cell-text::after {
  margin-left: 4px;
  font-size: 12px;
}

/* Custom sorted column header styling */
.server-side-datatable .sorted-column-header {
  background-color: #f0f7ff;
  font-weight: 700;
}

/* Resize handle styling */
.server-side-datatable .ag-header-cell-resize {
  opacity: 0.5;
}

.server-side-datatable .ag-header-cell-resize:hover {
  opacity: 1;
}

/* Hide scrollbars by default; show them when the grid is hovered */
/* Default: hidden (Firefox) */
.server-side-datatable .ag-body-viewport,
.server-side-datatable .ag-center-cols-viewport,
.server-side-datatable .ag-body-vertical-scroll,
.server-side-datatable .ag-body-horizontal-scroll {
  scrollbar-width: none;
}

/* Default: hidden (WebKit) */
.server-side-datatable .ag-body-viewport::-webkit-scrollbar,
.server-side-datatable .ag-center-cols-viewport::-webkit-scrollbar,
.server-side-datatable .ag-body-vertical-scroll::-webkit-scrollbar,
.server-side-datatable .ag-body-horizontal-scroll::-webkit-scrollbar {
  width: 0;
  height: 0;
}

/* Fade out AG’s separate scrollbar gutters until hover */
.server-side-datatable .ag-body-vertical-scroll,
.server-side-datatable .ag-body-horizontal-scroll {
  opacity: 0;
  transition: opacity 0.15s ease;
}

/* On hover: show and style scrollbars (sync preserved) */
.server-side-datatable .ag-root-wrapper:hover .ag-body-viewport,
.server-side-datatable .ag-root-wrapper:hover .ag-center-cols-viewport,
.server-side-datatable .ag-root-wrapper:hover .ag-body-vertical-scroll,
.server-side-datatable .ag-root-wrapper:hover .ag-body-horizontal-scroll {
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #c1c1c1 #f1f1f1; /* Firefox */
}

.server-side-datatable
  .ag-root-wrapper:hover
  .ag-body-viewport::-webkit-scrollbar,
.server-side-datatable
  .ag-root-wrapper:hover
  .ag-center-cols-viewport::-webkit-scrollbar,
.server-side-datatable
  .ag-root-wrapper:hover
  .ag-body-vertical-scroll::-webkit-scrollbar,
.server-side-datatable
  .ag-root-wrapper:hover
  .ag-body-horizontal-scroll::-webkit-scrollbar {
  width: 12px;
  height: 12px;
  background-color: #f5f5f5;
}

.server-side-datatable
  .ag-root-wrapper:hover
  .ag-body-viewport::-webkit-scrollbar-track,
.server-side-datatable
  .ag-root-wrapper:hover
  .ag-center-cols-viewport::-webkit-scrollbar-track,
.server-side-datatable
  .ag-root-wrapper:hover
  .ag-body-vertical-scroll::-webkit-scrollbar-track,
.server-side-datatable
  .ag-root-wrapper:hover
  .ag-body-horizontal-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 6px;
}

.server-side-datatable
  .ag-root-wrapper:hover
  .ag-body-viewport::-webkit-scrollbar-thumb,
.server-side-datatable
  .ag-root-wrapper:hover
  .ag-center-cols-viewport::-webkit-scrollbar-thumb,
.server-side-datatable
  .ag-root-wrapper:hover
  .ag-body-vertical-scroll::-webkit-scrollbar-thumb,
.server-side-datatable
  .ag-root-wrapper:hover
  .ag-body-horizontal-scroll::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 6px;
  border: 2px solid #f1f1f1;
}

.server-side-datatable
  .ag-root-wrapper:hover
  .ag-body-viewport::-webkit-scrollbar-thumb:hover,
.server-side-datatable
  .ag-root-wrapper:hover
  .ag-center-cols-viewport::-webkit-scrollbar-thumb:hover,
.server-side-datatable
  .ag-root-wrapper:hover
  .ag-body-vertical-scroll::-webkit-scrollbar-thumb:hover,
.server-side-datatable
  .ag-root-wrapper:hover
  .ag-body-horizontal-scroll::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.server-side-datatable .ag-root-wrapper:hover .ag-body-vertical-scroll,
.server-side-datatable .ag-root-wrapper:hover .ag-body-horizontal-scroll {
  opacity: 1;
}

/* Keep Ag-Grid’s own logic for showing/hiding scrollbars */
.server-side-datatable .ag-scrollbar-invisible {
  /* no overflow overrides here */
}

/* Context menu styling */
.server-side-datatable .ag-menu {
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background-color: white;
}

.server-side-datatable .ag-menu-option {
  padding: 8px 12px;
  font-size: 13px;
}

.server-side-datatable .ag-menu-option:hover {
  background-color: #f5f5f5;
}

/* Column drop zone styling */
.server-side-datatable .ag-column-drop {
  background-color: #f8f9fa;
  border: 1px dashed #ddd;
  border-radius: 4px;
  padding: 8px;
  margin: 4px 0;
}

/* Text alignment utilities */
.server-side-datatable .ag-cell.ag-cell-value.text-center {
  justify-content: center;
}

.server-side-datatable .ag-cell.ag-cell-value.text-right {
  justify-content: flex-end;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .server-side-datatable .ag-header-cell,
  .server-side-datatable .ag-cell {
    padding: 6px 8px;
    font-size: 12px;
  }

  .server-side-datatable .ag-header-cell-text {
    font-size: 12px;
  }
}

/* Print styles */
@media print {
  .server-side-datatable .ag-row:hover {
    background-color: transparent;
  }

  .server-side-datatable .ag-paging-panel {
    display: none;
  }
}

.server-side-datatable .ag-row:hover {
  background-color: transparent;
}

.server-side-datatable .ag-paging-panel {
  display: none;
}

/* Selection column header alignment with its content cells */
.server-side-datatable .ag-header-cell[col-id="ag-Grid-SelectionColumn"] {
  padding-left: 13px !important;
}

/* aligns header cell label with its content cells */
.server-side-datatable .ag-header-cell-label {
  padding-left: 4px !important;
}

/* Ensure grid viewports can shrink inside flex containers */
.server-side-datatable .ag-root-wrapper,
.server-side-datatable .ag-root,
.server-side-datatable .ag-body-viewport,
.server-side-datatable .ag-center-cols-viewport {
  min-height: 0 !important;
}

.server-side-datatable .ag-row-last {
}

.server-side-datatable .ag-center-cols-viewport {
  margin-bottom: 52px;
}

/* Unified tooltip styling to match dark rounded design */
.server-side-datatable .ag-tooltip,
.server-side-datatable .ag-tooltip .ag-tooltip-content,
.server-side-datatable .MuiTooltip-tooltip {
  background: rgba(66, 66, 66, 0.92) !important;
  color: #ffffff !important;
  border-radius: 6px !important;
  padding: 6px 10px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
  font-family: "Poppins", sans-serif !important;
  font-size: 13px !important;
  line-height: 20px !important;
}

/* Optional: tooltip arrow color when used */
.server-side-datatable .MuiTooltip-arrow {
  color: rgba(66, 66, 66, 0.92) !important;
}

/* Constrain tooltip dimensions to prevent layout shifts */
.server-side-datatable .ag-tooltip,
.server-side-datatable .ag-tooltip .ag-tooltip-content {
  max-width: 400px !important;
  max-height: 200px !important;
}

/* Prevent tooltip from affecting grid layout */
.server-side-datatable .ag-tooltip {
  z-index: 9999 !important;
  pointer-events: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/aggrid.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,wFAAwF;AACxF;;;EAGE,6CAA6C;EAC7C,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,yDAAyD;AACzD;;;;EAIE,6CAA6C;EAC7C,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA,4BAA4B;AAC5B;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA,2BAA2B;AAC3B;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,mEAAmE;AACnE,8BAA8B;AAC9B;;;;EAIE,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;;;;EAIE,QAAQ;EACR,SAAS;AACX;;AAEA,yDAAyD;AACzD;;EAEE,UAAU;EACV,8BAA8B;AAChC;;AAEA,yDAAyD;AACzD;;;;EAIE,qBAAqB,EAAE,YAAY;EACnC,gCAAgC,EAAE,YAAY;AAChD;;AAEA;;;;;;;;;;;;EAYE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;EAYE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;EAYE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;EAYE,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;AACZ;;AAEA,2DAA2D;AAC3D;EACE,+BAA+B;AACjC;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA,6DAA6D;AAC7D;EACE,6BAA6B;AAC/B;;AAEA,oDAAoD;AACpD;EACE,4BAA4B;AAC9B;;AAEA,4DAA4D;AAC5D;;;;EAIE,wBAAwB;AAC1B;;AAEA;AACA;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;;;EAGE,6CAA6C;EAC7C,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,mDAAmD;EACnD,6CAA6C;EAC7C,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,4CAA4C;AAC5C;EACE,wCAAwC;AAC1C;;AAEA,0DAA0D;AAC1D;;EAEE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,+CAA+C;AAC/C;EACE,wBAAwB;EACxB,+BAA+B;AACjC","sourcesContent":["/* Header styling */\n\n.server-side-datatable {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n}\n\n.server-side-datatable .loading-overlay {\n  position: relative;\n  z-index: 100;\n}\n\n.server-side-datatable .table-header {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0px;\n  margin-top: 0px;\n  padding: 0px 8px;\n  min-height: 44px;\n}\n\n.server-side-datatable .custom-ag-table-container {\n  flex: 1;\n  min-height: 0;\n  margin-left: 4px;\n  margin-right: 4px;\n}\n\n.server-side-datatable .ag-header {\n  border-bottom: 2px solid #e0e0e0;\n  font-weight: 600;\n}\n\n.server-side-datatable .ag-header-cell {\n  border-right: 1px solid #e0e0e0;\n  padding: 8px 12px;\n}\n\n.server-side-datatable .ag-header-cell-text {\n  font-weight: 600;\n  font-size: 13px;\n}\n\n/* Row styling */\n.server-side-datatable .ag-row {\n  border-bottom: 1px solid #f0f0f0;\n  transition: background-color 0.2s ease;\n}\n\n.server-side-datatable .ag-row:hover {\n  background-color: #f8f9fa;\n}\n\n.server-side-datatable .ag-row.ag-row-selected {\n  background-color: #e3f2fd;\n}\n\n.server-side-datatable .ag-row.ag-row-selected:hover {\n  background-color: #bbdefb;\n}\n\n/* Cell styling */\n.server-side-datatable .ag-cell {\n  border-right: 1px solid #f0f0f0;\n  padding: 8px 12px;\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n/* Typography overrides: Poppins, 14px, 24px line-height, 400 weight, rgba(0,0,0,0.87) */\n.server-side-datatable .ag-header,\n.server-side-datatable .ag-header-cell,\n.server-side-datatable .ag-header .ag-header-cell-text {\n  font-family: \"Poppins\", sans-serif !important;\n  font-size: 14px !important;\n  line-height: 24px !important;\n  font-weight: 500 !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n\n.server-side-datatable .ag-cell {\n  font-family: \"Poppins\", sans-serif !important;\n  font-size: 14px !important;\n  line-height: 24px !important;\n  font-weight: 400 !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n\n/* Menus, lists and overlays keep consistent typography */\n.server-side-datatable .ag-menu,\n.server-side-datatable .ag-virtual-list-item,\n.server-side-datatable .ag-overlay-loading-center,\n.server-side-datatable .ag-overlay-no-rows-center {\n  font-family: \"Poppins\", sans-serif !important;\n  font-size: 14px !important;\n  line-height: 24px !important;\n  font-weight: 400 !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n\n/* Checkbox styling */\n.server-side-datatable .ag-selection-checkbox {\n  margin-right: 8px;\n}\n\n/* Loading overlay styling */\n.server-side-datatable .ag-overlay-loading-wrapper {\n  background-color: rgba(255, 255, 255, 0.9);\n}\n\n.server-side-datatable .ag-overlay-loading-center {\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* No rows overlay styling */\n.server-side-datatable .ag-overlay-no-rows-wrapper {\n  background-color: rgba(255, 255, 255, 0.9);\n}\n\n.server-side-datatable .ag-overlay-no-rows-center {\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 20px;\n  font-size: 14px;\n  color: #666;\n}\n\n/* Pagination styling */\n.server-side-datatable .ag-paging-panel {\n  border-top: 1px solid #e0e0e0;\n  background-color: #fafafa;\n  padding: 8px 12px;\n}\n\n.server-side-datatable .ag-paging-button {\n  border: 1px solid #ddd;\n  background-color: white;\n  margin: 0 2px;\n  border-radius: 3px;\n  padding: 4px 8px;\n  font-size: 12px;\n}\n\n.server-side-datatable .ag-paging-button:hover:not(.ag-disabled) {\n  background-color: #f5f5f5;\n}\n\n.server-side-datatable .ag-paging-button.ag-disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Filter styling */\n.server-side-datatable .ag-filter-toolpanel {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Sort indicator styling */\n.server-side-datatable .ag-header-cell-sorted-asc .ag-header-cell-text::after,\n.server-side-datatable .ag-header-cell-sorted-desc .ag-header-cell-text::after {\n  margin-left: 4px;\n  font-size: 12px;\n}\n\n/* Custom sorted column header styling */\n.server-side-datatable .sorted-column-header {\n  background-color: #f0f7ff;\n  font-weight: 700;\n}\n\n/* Resize handle styling */\n.server-side-datatable .ag-header-cell-resize {\n  opacity: 0.5;\n}\n\n.server-side-datatable .ag-header-cell-resize:hover {\n  opacity: 1;\n}\n\n/* Hide scrollbars by default; show them when the grid is hovered */\n/* Default: hidden (Firefox) */\n.server-side-datatable .ag-body-viewport,\n.server-side-datatable .ag-center-cols-viewport,\n.server-side-datatable .ag-body-vertical-scroll,\n.server-side-datatable .ag-body-horizontal-scroll {\n  scrollbar-width: none;\n}\n\n/* Default: hidden (WebKit) */\n.server-side-datatable .ag-body-viewport::-webkit-scrollbar,\n.server-side-datatable .ag-center-cols-viewport::-webkit-scrollbar,\n.server-side-datatable .ag-body-vertical-scroll::-webkit-scrollbar,\n.server-side-datatable .ag-body-horizontal-scroll::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n/* Fade out AG’s separate scrollbar gutters until hover */\n.server-side-datatable .ag-body-vertical-scroll,\n.server-side-datatable .ag-body-horizontal-scroll {\n  opacity: 0;\n  transition: opacity 0.15s ease;\n}\n\n/* On hover: show and style scrollbars (sync preserved) */\n.server-side-datatable .ag-root-wrapper:hover .ag-body-viewport,\n.server-side-datatable .ag-root-wrapper:hover .ag-center-cols-viewport,\n.server-side-datatable .ag-root-wrapper:hover .ag-body-vertical-scroll,\n.server-side-datatable .ag-root-wrapper:hover .ag-body-horizontal-scroll {\n  scrollbar-width: thin; /* Firefox */\n  scrollbar-color: #c1c1c1 #f1f1f1; /* Firefox */\n}\n\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-body-viewport::-webkit-scrollbar,\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-center-cols-viewport::-webkit-scrollbar,\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-body-vertical-scroll::-webkit-scrollbar,\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-body-horizontal-scroll::-webkit-scrollbar {\n  width: 12px;\n  height: 12px;\n  background-color: #f5f5f5;\n}\n\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-body-viewport::-webkit-scrollbar-track,\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-center-cols-viewport::-webkit-scrollbar-track,\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-body-vertical-scroll::-webkit-scrollbar-track,\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-body-horizontal-scroll::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 6px;\n}\n\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-body-viewport::-webkit-scrollbar-thumb,\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-center-cols-viewport::-webkit-scrollbar-thumb,\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-body-vertical-scroll::-webkit-scrollbar-thumb,\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-body-horizontal-scroll::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 6px;\n  border: 2px solid #f1f1f1;\n}\n\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-body-viewport::-webkit-scrollbar-thumb:hover,\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-center-cols-viewport::-webkit-scrollbar-thumb:hover,\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-body-vertical-scroll::-webkit-scrollbar-thumb:hover,\n.server-side-datatable\n  .ag-root-wrapper:hover\n  .ag-body-horizontal-scroll::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n.server-side-datatable .ag-root-wrapper:hover .ag-body-vertical-scroll,\n.server-side-datatable .ag-root-wrapper:hover .ag-body-horizontal-scroll {\n  opacity: 1;\n}\n\n/* Keep Ag-Grid’s own logic for showing/hiding scrollbars */\n.server-side-datatable .ag-scrollbar-invisible {\n  /* no overflow overrides here */\n}\n\n/* Context menu styling */\n.server-side-datatable .ag-menu {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  background-color: white;\n}\n\n.server-side-datatable .ag-menu-option {\n  padding: 8px 12px;\n  font-size: 13px;\n}\n\n.server-side-datatable .ag-menu-option:hover {\n  background-color: #f5f5f5;\n}\n\n/* Column drop zone styling */\n.server-side-datatable .ag-column-drop {\n  background-color: #f8f9fa;\n  border: 1px dashed #ddd;\n  border-radius: 4px;\n  padding: 8px;\n  margin: 4px 0;\n}\n\n/* Text alignment utilities */\n.server-side-datatable .ag-cell.ag-cell-value.text-center {\n  justify-content: center;\n}\n\n.server-side-datatable .ag-cell.ag-cell-value.text-right {\n  justify-content: flex-end;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .server-side-datatable .ag-header-cell,\n  .server-side-datatable .ag-cell {\n    padding: 6px 8px;\n    font-size: 12px;\n  }\n\n  .server-side-datatable .ag-header-cell-text {\n    font-size: 12px;\n  }\n}\n\n/* Print styles */\n@media print {\n  .server-side-datatable .ag-row:hover {\n    background-color: transparent;\n  }\n\n  .server-side-datatable .ag-paging-panel {\n    display: none;\n  }\n}\n\n.server-side-datatable .ag-row:hover {\n  background-color: transparent;\n}\n\n.server-side-datatable .ag-paging-panel {\n  display: none;\n}\n\n/* Selection column header alignment with its content cells */\n.server-side-datatable .ag-header-cell[col-id=\"ag-Grid-SelectionColumn\"] {\n  padding-left: 13px !important;\n}\n\n/* aligns header cell label with its content cells */\n.server-side-datatable .ag-header-cell-label {\n  padding-left: 4px !important;\n}\n\n/* Ensure grid viewports can shrink inside flex containers */\n.server-side-datatable .ag-root-wrapper,\n.server-side-datatable .ag-root,\n.server-side-datatable .ag-body-viewport,\n.server-side-datatable .ag-center-cols-viewport {\n  min-height: 0 !important;\n}\n\n.server-side-datatable .ag-row-last {\n}\n\n.server-side-datatable .ag-center-cols-viewport {\n  margin-bottom: 52px;\n}\n\n/* Unified tooltip styling to match dark rounded design */\n.server-side-datatable .ag-tooltip,\n.server-side-datatable .ag-tooltip .ag-tooltip-content,\n.server-side-datatable .MuiTooltip-tooltip {\n  background: rgba(66, 66, 66, 0.92) !important;\n  color: #ffffff !important;\n  border-radius: 6px !important;\n  padding: 6px 10px !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;\n  font-family: \"Poppins\", sans-serif !important;\n  font-size: 13px !important;\n  line-height: 20px !important;\n}\n\n/* Optional: tooltip arrow color when used */\n.server-side-datatable .MuiTooltip-arrow {\n  color: rgba(66, 66, 66, 0.92) !important;\n}\n\n/* Constrain tooltip dimensions to prevent layout shifts */\n.server-side-datatable .ag-tooltip,\n.server-side-datatable .ag-tooltip .ag-tooltip-content {\n  max-width: 400px !important;\n  max-height: 200px !important;\n}\n\n/* Prevent tooltip from affecting grid layout */\n.server-side-datatable .ag-tooltip {\n  z-index: 9999 !important;\n  pointer-events: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
